'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SystemMessage = require('./components/SystemMessage.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SystemMessage).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-system-message/lib/index.js
// module id = 1512
// module chunks = 1